import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import Loading from '../../../Images/loading.gif'
import '../../../CSS/global.css'
import './DashboardAdminModifySchedule.css'
import { destroySession } from '../../../Utility/Utility';
import { CleanersAdminSearchStore } from '../../../CleanersDashboardAdminAPI/CleanersAdminSearchStoreAPi';
import { StoresDropDownCleaningSchedule } from '../../../CleanersDashboardAdminAPI/CleanersAdminStoresCleaningScheduleAPI'
import { GetDomainDropDown } from '../../../CleanersDashboardAPI/CleanersDashboardDropDownAPi'
import { UpdateCleanerSchedule } from '../../../CleanersDashboardAdminAPI/CleanersAdminUpdateScheduleApi'
import { CleanersAdminAddCleaner } from '../../../CleanersDashboardAdminAPI/CleanersAdminAddCleanerApi'
import * as DashboardAdminModifyScheduleConstant from './DashboardAdminModifyScheduleConstant'
import { isIE } from 'react-device-detect';
import { IoIosClose, IoMdSearch } from "react-icons/io";
import { CloseIcon } from '../../../Images/CloseIcon.svg'
import Modal from 'react-modal';
import { FaRegEdit } from "react-icons/fa";
import { IconContext } from "react-icons";
import DashboardCleanersAdminHeader from '../../../CleanersDashboardComponents/Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
const $ = require('jquery')



class DashboardAdminModifySchedule extends Component {
    constructor(props) {
        super(props)
        this.state = {
            storeId: '',
            arrayCleanerSchedule: [],
            modalIsOpen: false,
            SupplierName: "",
            StoreName: "",
            arraySuppliername: [],
            arrayStores: [],
            AddButtonEnable: false,
            Sun: '',
            Mon: '',
            Tue: '',
            Wed: '',
            Thu: '',
            Fri: '',
            Sat: '',
            AddSucess: false,
            CleanerAlreadyPresent: false,
            modalIsOpenEdit: false,
            StoreIdEdit: '',
            UpdateSuccess: false,
            CleanerCount: false,
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            elementStoreId: false,
            errorStoreId: "",
            VendorName: "",
            InvalidStore: false,
            arrayDomains: [],
            role: '',
            SuperAdminVendorName: "",
            errorMessage: '',
            emptyStore: false,
            emptySupplierName: false,
            Ie: false
        }
        this.handleChangeStore = this.handleChangeStore.bind(this);
        this.handleSearchStore = this.handleSearchStore.bind(this);
        this.handleStoreName = this.handleStoreName.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSaveEdit = this.handleSaveEdit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSupplierName = this.handleSupplierName.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModalEdit = this.openModalEdit.bind(this);
        this.afterOpenModalEdit = this.afterOpenModalEdit.bind(this);
        this.closeModalEdit = this.closeModalEdit.bind(this);
        this.SuperAdminVendorName = "";
        this.VendorName = ""

    }
    componentWillMount() {
        this.VendorName = sessionStorage.getItem('vendorName')
        this.setState({
            // VendorName: sessionStorage.getItem('vendorName'),
            role: sessionStorage.getItem('role')
        })
        if (isIE) {
            this.setState({
                Ie: true
            })
        }
    }
    componentDidMount() {
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        let UserId = sessionStorage.getItem('userId')
        let arrayStores = []
        if (this.state.role == "3") {
            StoresDropDownCleaningSchedule(UserId, AuthStr).then(res => {
                let responseJSON = res;
                if (responseJSON.status == 200) {
                    let arrayresponse = responseJSON.data
                    Object.keys(arrayresponse).forEach(function (key) {
                        arrayStores.push({
                            StoreId: arrayresponse[key].storeId, StoreName: arrayresponse[key].name,
                        })
                    });
                    this.setState({
                        arrayStores: arrayStores

                    })
                    GetDomainDropDown().then(res => {
                        let responseJSON = res
                        let arrayDomains = []
                        if (responseJSON.status === 200) {
                            let arrayDomainsResponse = responseJSON.data.vendorName
                            Object.keys(arrayDomainsResponse).forEach(function (key) {
                                arrayDomains.push({
                                    SupplierNames: arrayDomainsResponse[key]
                                })
                            })
                            this.setState({
                                loading: false,
                                arrayDomains: arrayDomains,
                                AddButtonEnable: true

                            })
                        }
                        else if (responseJSON.status == 400) {
                            this.setState({
                                redirectError400: true,
                                loading: false
                            })
                        }
                        else if (responseJSON.status == 401) {
                            this.setState({
                                redirectError401: true,
                                loading: false
                            })
                        }
                        else if (responseJSON.status == 404) {
                            this.setState({
                                redirectError404: true,
                                loading: false
                            })
                        }
                        else if (responseJSON.status == 500) {
                            this.setState({
                                redirectError500: true,
                                loading: false
                            })
                        }

                    })
                }
                else if (responseJSON.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 404) {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }

            })

        }
        else {
            StoresDropDownCleaningSchedule(UserId, AuthStr).then(res => {
                let responseJSON = res;
                if (responseJSON.status == 200) {
                    let arrayresponse = responseJSON.data
                    Object.keys(arrayresponse).forEach(function (key) {
                        arrayStores.push({
                            StoreId: arrayresponse[key].storeId, StoreName: arrayresponse[key].name,
                        })
                    });
                    this.setState({
                        arrayStores: arrayStores,
                        AddButtonEnable: true
                    })
                }
                else if (responseJSON.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 404) {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
                }
                else if (responseJSON.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }

            }
            )
        }
    }
    handleClose = (e) => {
        this.setState({
            UpdateSuccess: false,
            AddSucess: false
        })
    }
    handleSaveEdit() {
        this.setState({
            loading: true
        })
        let StoreIdBacked = this.state.arrayCleanerSchedule.map((x) => {
            return x.StoreIdBacked + ""
        }
        )
        let UserId = sessionStorage.getItem('userId')
        let AuthData = {
            // StoreName: this.state.StoreName,
            // SupplierName: this.state.SupplierName,
            Sunday: this.state.Sun,
            Monday: this.state.Mon,
            Tuesday: this.state.Tue,
            Wednesday: this.state.Wed,
            Thursday: this.state.Thu,
            Friday: this.state.Fri,
            Saturday: this.state.Sat,
            StoreID: StoreIdBacked[0]
        }
        if (AuthData.Sunday == "") {
            AuthData.Sunday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Sun = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Monday == "") {
            AuthData.Monday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Mon = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Tuesday == "") {
            AuthData.Tuesday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Tue = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Wednesday == "") {
            AuthData.Wednesday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Wed = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Thursday == "") {
            AuthData.Thursday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Thu = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Friday == "") {
            AuthData.Friday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Fri = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        if (AuthData.Saturday == "") {
            AuthData.Saturday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            this.state.Sat = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
        }
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        UpdateCleanerSchedule(AuthData, UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    modalIsOpenEdit: false,
                    UpdateSuccess: true
                })
                this.handleSearchStore();
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }
        })

    }
    handleSun = (e) => {
        this.setState({
            Sun: e.target.value
        })
    }
    handleMon = (e) => {
        this.setState({
            Mon: e.target.value
        })
    }
    handleTue = (e) => {
        this.setState({
            Tue: e.target.value
        })
    }
    handleWed = (e) => {
        this.setState({
            Wed: e.target.value
        })
    }
    handleThu = (e) => {
        this.setState({
            Thu: e.target.value
        })
    }
    handleFri = (e) => {
        this.setState({
            Fri: e.target.value
        })
    }
    handleSat = (e) => {
        this.setState({
            Sat: e.target.value
        })
    }
    handleSupplierName(e) {
        this.VendorName = e.target.value
        this.setState({
            emptySupplierName: false
        })
    }
    handleSuperAdminSupplierName = (e) => {
        this.SuperAdminVendorName = e.target.value
        this.setState({
            emptySupplierName: false
        })
    }
    handleStoreName(e) {
        this.setState({
            StoreName: e.target.value,
            CleanerAlreadyPresent: false,
            emptyStore: false
        })
    }
    handleSave(e) {
        var apiFlag = true
        if (this.state.StoreName == "" || this.state.StoreName == "Select") {
            this.setState({
                emptyStore: true
            })
            apiFlag = false
        }
        if (this.SuperAdminVendorName == "" || this.SuperAdminVendorName == "Select") {
            if (this.state.role == "3") {
                this.setState({
                    emptySupplierName: true
                })
                apiFlag = false
            }
        }
        if (this.VendorName == "" || this.VendorName == "Select") {
            if (this.state.role == "1") {
                this.setState({
                    emptySupplierName: true
                })
                apiFlag = false
            }
        }
        if (apiFlag) {
            this.setState({
                loading: true
            })
            var FinalStoreName = this.state.StoreName.replace(/ *\([^A-z)]*\) */g, "")   /* blocking numbers in ()*/
            this.setState({
                StoreName: FinalStoreName
            })
            let UserId = sessionStorage.getItem('userId')
            let AuthData = {
                StoreName: FinalStoreName,
                SupplierName: this.VendorName,
                Sunday: this.state.Sun,
                Monday: this.state.Mon,
                Tuesday: this.state.Tue,
                Wednesday: this.state.Wed,
                Thursday: this.state.Thu,
                Friday: this.state.Fri,
                Saturday: this.state.Sat
            }
            if (AuthData.Sunday == "") {
                AuthData.Sunday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Sun = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Monday == "") {
                AuthData.Monday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Mon = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Tuesday == "") {
                AuthData.Tuesday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Tue = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Wednesday == "") {
                AuthData.Wednesday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Wed = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Thursday == "") {
                AuthData.Thursday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Thu = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Friday == "") {
                AuthData.Friday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Fri = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (AuthData.Saturday == "") {
                AuthData.Saturday = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
                this.state.Sat = DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty
            }
            if (this.state.role == "3") {
                AuthData.SupplierName = this.SuperAdminVendorName
            }
            let TokenDataApi = sessionStorage.getItem('token');
            const AuthStr = 'bearer '.concat(TokenDataApi);
            CleanersAdminAddCleaner(AuthData, UserId, AuthStr).then(res => {
                if (res.status == 200) {
                    this.setState({
                        AddSucess: true,
                        modalIsOpen: false,
                        CleanerAlreadyPresent: false,
                        loading: false
                    })
                    this.setState({
                        storeId : AuthData.StoreName
                    })
                    this.handleSearchStore();
                    this.componentDidMount();
                }
                else if (res.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (res.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (res.status == 404) {
                    if (res.data.description == "CleanerSchedule for store is already present") { /* Backend Custom Error for Cleaner Alredy*/
                        this.setState({
                            CleanerAlreadyPresent: true,
                            loading: false
                        })
                    }
                    else {
                        this.setState({
                            redirectError404: true,
                            loading: false
                        })
                    }
                }
                else if (res.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }
            })
        }


    }
    handleCancel(e) {
        this.setState({ modalIsOpen: false })
    }
    handleChangeStore(e) {
        this.setState({
            storeId: e.target.value,
            elementStoreId: false,
            InvalidStore: false
        })
    }

    openModal() {
        this.setState({
            modalIsOpen: true,
            Sun: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Mon: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Tue: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Wed: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Thu: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Fri: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
            Sat: DashboardAdminModifyScheduleConstant.CleaningScheduleEmpty,
        })
    }

    afterOpenModal() {


    }

    closeModal() {
        this.setState({
            modalIsOpen: false,
            CleanerAlreadyPresent: false,
            emptySupplierName: false,
            emptyStore: false
        });
    }


    openModalEdit() {
        this.setState({
            modalIsOpenEdit: true
        })
    }

    afterOpenModalEdit() {

    }
    handleKeyPressStore = (e) => {
        if (e.key == 'Enter') {
            this.handleSearchStore();
        }
    }
    closeModalEdit() {
        this.setState({
            modalIsOpenEdit: false,
        });
    }
    handleSearchStore(e) {
        this.setState({
            loading: true
        })
        let AuthData = {
            UserId: sessionStorage.getItem('userId'),
            SearchText: this.state.storeId
        }
        if (AuthData.SearchText == "") {
            let errorStoreId = ""
            errorStoreId = DashboardAdminModifyScheduleConstant.StoreEmpty
            this.setState({
                loading: false,
                elementStoreId: true,
                errorStoreId: errorStoreId
            })
        }
        else {
            let arrayCleanerSchedule = []
            let TokenDataApi = sessionStorage.getItem('token');
            const AuthStr = 'bearer '.concat(TokenDataApi);
            CleanersAdminSearchStore(AuthData, AuthStr).then(res => {
                if (res.status == 200) {
                    let CleanerSchedule = res.data.cleanerSchedule
                    Object.keys(CleanerSchedule).forEach(function (key) {
                        arrayCleanerSchedule.push({
                            StoreIdBacked: CleanerSchedule[key].store.storeId,
                            StoreId: CleanerSchedule[key].store.hubId,
                            StoreName: CleanerSchedule[key].store.name,
                            SupplierName: CleanerSchedule[key].supplierName,
                            Sun: CleanerSchedule[key].sunday,
                            Mon: CleanerSchedule[key].monday,
                            Tue: CleanerSchedule[key].tuesday,
                            Wed: CleanerSchedule[key].wednesday,
                            Thu: CleanerSchedule[key].thursday,
                            Fri: CleanerSchedule[key].friday,
                            Sat: CleanerSchedule[key].saturday
                        })

                    })
                    this.setState({
                        arrayCleanerSchedule: arrayCleanerSchedule,
                        loading: false
                    })
                }
                else if (res.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (res.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (res.status == 404) {
                    var ErrorMessage = res.data.description
                    if (ErrorMessage != "") {
                        let errorMessage = ErrorMessage.substring(ErrorMessage.lastIndexOf("(") + 1, ErrorMessage.lastIndexOf(")"));
                        this.setState({
                            InvalidStore: true,
                            loading: false,
                            errorMessage: errorMessage
                        })

                    }
                    else {
                        this.setState({
                            redirectError404: true,
                            loading: false
                        })
                    }
                }
                else if (res.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }

            })
        }

    }

    handleEdit = (StoreId, StoreName, SupplierName, Sun, Mon, Tue, Wed, Thu, Fri, Sat) => {
        this.openModalEdit();
        this.setState({
            StoreIdEdit: StoreId,
            StoreName: StoreName,
            SupplierName: SupplierName,
            Sun: Sun,
            Mon: Mon,
            Tue: Tue,
            Wed: Wed,
            Thu: Thu,
            Fri: Fri,
            Sat: Sat,
        })
    }
    handleKeyPressDates = (e) => {
        var Regex = /[0-9]{1,2}/
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        var Cond = Regex.test(key)
        if (!(Cond)) {
            e.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }


    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersAdminDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersAdminDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersAdminDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersAdminDashboardError500'} />)
        }
        return (
            <div>
                <DashboardCleanersAdminHeader />
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                {this.state.AddSucess ? <div className="loadingUploadedMessage"><p className="messageUploaded">{DashboardAdminModifyScheduleConstant.ScheduleAdded} <span ><IoIosClose className="UpdateClose" onClick={this.handleClose} /></span> </p>  </div> : null}
                {this.state.UpdateSuccess ? <div className="loadingUploadedMessage"><p className="messageUploaded">{DashboardAdminModifyScheduleConstant.ScheduleUpdated}<span ><IoIosClose className="UpdateClose" onClick={this.handleClose} /></span> </p>  </div> : null}
                <div className="ModifySchedule">
                    <div className="FlexHead">
                        <h3>{DashboardAdminModifyScheduleConstant.ScheduleHead}</h3>
                        <ReusableButton className="NewSchedule" onClick={this.openModal} disabled={!(this.state.AddButtonEnable)} buttonText={DashboardAdminModifyScheduleConstant.NewSchedule}></ReusableButton>
                    </div>
                    {this.state.Ie ?
                        <ReusableTextBox className="StoreIdField" type="" onChange={this.handleChangeStore} placeholder={DashboardAdminModifyScheduleConstant.Search} onKeyPress={this.handleKeyPressStore}> </ReusableTextBox>
                        :
                        <ReusableTextBox className="StoreIdField" type="text" onChange={this.handleChangeStore} placeholder={DashboardAdminModifyScheduleConstant.Search} onKeyPress={this.handleKeyPressStore}> </ReusableTextBox>
                    }
                    {this.state.elementStoreId ?
                        <div>
                            <span className="ErrorStoreIdId">{this.state.errorStoreId}</span>
                        </div> : null}
                    {this.state.InvalidStore ? <span className="ErrorStoreIdId">{this.state.errorMessage}</span> : null}
                    <div>
                        <IconContext.Provider
                            value={{ className: "global-class-name_searchStore" }}

                        >
                            {this.state.Ie ?
                                <IoMdSearch onClick={this.handleSearchStore} className="searchiconStoreIE" />
                                :
                                <IoMdSearch onClick={this.handleSearchStore} className="searchiconStore" />}
                        </IconContext.Provider>
                    </div>
                    <div className="NoCleaners">
                        <span className="CleanersPerDay">{DashboardAdminModifyScheduleConstant.CleanersPerDay}</span>
                    </div>
                    <div className="TableData">
                        <table className="CleaningCompaniesData">
                            <thead>
                                <tr>
                                    <th>{DashboardAdminModifyScheduleConstant.StoreId}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.StoreName}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.SupplierName}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Sun}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Mon}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Tue}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Wed}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Thu}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Fri}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Sat}</th>
                                    <th>{DashboardAdminModifyScheduleConstant.Action}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.arrayCleanerSchedule.map((x, key) =>
                                    <tr key={key}>
                                        <td>{x.StoreId}</td>
                                        <td>{x.StoreName}</td>
                                        <td>{x.SupplierName}</td>
                                        <td>{x.Sun}</td>
                                        <td>{x.Mon}</td>
                                        <td>{x.Tue}</td>
                                        <td>{x.Wed}</td>
                                        <td>{x.Thu}</td>
                                        <td>{x.Fri}</td>
                                        <td>{x.Sat}</td>
                                        <td><FaRegEdit className="EditIcon" onClick={(a, b, c, d, e, f, g, h, i, j) => this.handleEdit(x.StoreId, x.StoreName, x.SupplierName, x.Sun, x.Mon, x.Tue, x.Wed, x.Thu, x.Fri, x.Sat)} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        className="ModalNewSchedule"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModal} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHead">
                            <h3>{DashboardAdminModifyScheduleConstant.CreateNew}</h3>
                            <p className="Mandotory"><span className="mandatoryField">*</span>{DashboardAdminModifyScheduleConstant.Mandatory}</p>
                            {this.state.CleanerAlreadyPresent ? <span className="CleanerAlready">{DashboardAdminModifyScheduleConstant.AlreadyPresent}</span> : null}
                            <div className="Dropdowns">
                                <div className="DropdownStores">
                                    <p>{DashboardAdminModifyScheduleConstant.StoreName}<span className="mandatoryField">*</span></p>
                                    <p className="blankStore">{this.state.emptyStore ? <p>{DashboardAdminModifyScheduleConstant.StoreNotSelect}</p> : null}</p>
                                    <select className="StoreNamesSelect" onChange={this.handleStoreName} id="StoreDefault">
                                        <option className="HeaderOption">{DashboardAdminModifyScheduleConstant.Select}</option>
                                        {this.state.arrayStores.map((x, key) =>
                                            <option id={key} className="HeaderOption" value={x.StoreName} key={key}>{x.StoreName}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="DropdownSupplier">
                                    <p className="SupplierPara">{DashboardAdminModifyScheduleConstant.SupplierName}<span className="mandatoryField">*</span></p>
                                    <p className="blankSupplier">{this.state.emptySupplierName ? <p>{DashboardAdminModifyScheduleConstant.SupplierNotSelect}</p> : null}</p>
                                    {this.state.role == "3" ?
                                        <select className="SupplierNamesSelect" onChange={this.handleSuperAdminSupplierName} id="SupplierSuperAdminDefault">
                                            <option className="HeaderOption">{DashboardAdminModifyScheduleConstant.Select}</option>
                                            {this.state.arrayDomains.map((x, key) =>
                                                <option id={key} className="HeaderOption" value={x.SupplierNames} key={key}>{x.SupplierNames}</option>
                                            )}
                                        </select>
                                        :
                                        <select className="SupplierNamesSelect" onChange={this.handleSupplierName} id="SupplierDefault">
                                            <option className="HeaderOption">{this.VendorName}</option>
                                        </select>}


                                </div>
                            </div>
                            <div className="CleanersDay">
                                <span className="CleanersPerDayNewSchedule">{DashboardAdminModifyScheduleConstant.CleanersPerDay}</span>
                            </div>
                            <div className="WeekDays">
                                <div className="Sun"><p>{DashboardAdminModifyScheduleConstant.Sun}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Sun} onChange={this.handleSun} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Mon"><p>{DashboardAdminModifyScheduleConstant.Mon} <span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Mon} onChange={this.handleMon} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Tue"><p>{DashboardAdminModifyScheduleConstant.Tue}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Tue} onChange={this.handleTue} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Wed"><p>{DashboardAdminModifyScheduleConstant.Wed}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Wed} onChange={this.handleWed} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Thu"><p>{DashboardAdminModifyScheduleConstant.Thu}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Thu} onChange={this.handleThu} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Fri"><p>{DashboardAdminModifyScheduleConstant.Fri}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Fri} onChange={this.handleFri} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Sat"><p>{DashboardAdminModifyScheduleConstant.Sat}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Sat} onChange={this.handleSat} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                            </div>
                            <div className="ButtonsModal">
                                <p className="CancelModal" onClick={this.closeModal}>{DashboardAdminModifyScheduleConstant.Cancel}</p>
                                <ReusableButton className="SaveFieldModal" buttonText="Save" onClick={this.handleSave} />
                            </div>
                        </div>
                    </Modal>

                    {/* Edit Schedule*/}


                    <Modal
                        isOpen={this.state.modalIsOpenEdit}
                        onAfterOpen={this.afterOpenModalEdit}
                        onRequestClose={this.closeModalEdit}
                        className="ModalNewSchedule"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModalEdit} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHead">
                            <h3>{DashboardAdminModifyScheduleConstant.EditSchedule}</h3>
                            <p className="Mandotory"><span className="mandatoryField">*</span>{DashboardAdminModifyScheduleConstant.Mandatory}</p>
                            <div className="Dropdowns">
                                <div className="DropdownStores">
                                    <p><span className="EditSpan">{DashboardAdminModifyScheduleConstant.StoreId}</span></p>
                                    <p>{this.state.StoreIdEdit}</p>
                                </div>
                                <div className="DropdownSupplier">
                                    <p><span className="EditSpan">{DashboardAdminModifyScheduleConstant.StoreName}</span></p>
                                    <p>{this.state.StoreName}</p>
                                </div>
                                <div className="DropdownSupplier">
                                    <p><span className="EditSpan">{DashboardAdminModifyScheduleConstant.SupplierName}</span></p>
                                    <p>{this.state.SupplierName}</p>
                                </div>
                            </div>
                            <div className="CleanersDay">
                                <span className="CleanersPerDayNewSchedule">{DashboardAdminModifyScheduleConstant.CleanersPerDay}</span>
                            </div>
                            <div className="WeekDays">
                                <div className="Sun"><p>{DashboardAdminModifyScheduleConstant.Sun}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Sun} onChange={this.handleSun} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Mon"><p>{DashboardAdminModifyScheduleConstant.Mon} <span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Mon} onChange={this.handleMon} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Tue"><p>{DashboardAdminModifyScheduleConstant.Tue}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Tue} onChange={this.handleTue} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Wed"><p>{DashboardAdminModifyScheduleConstant.Wed}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Wed} onChange={this.handleWed} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Thu"><p>{DashboardAdminModifyScheduleConstant.Thu}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Thu} onChange={this.handleThu} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Fri"><p>{DashboardAdminModifyScheduleConstant.Fri}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Fri} onChange={this.handleFri} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                                <div className="Sat"><p>{DashboardAdminModifyScheduleConstant.Sat}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="SunField" type="text" value={this.state.Sat} onChange={this.handleSat} maxlength="2" onKeyPress={(e) => this.handleKeyPressDates(e)} />
                                </div>
                            </div>
                            <div className="ButtonsModal">
                                <p className="CancelModal" onClick={this.closeModalEdit}>{DashboardAdminModifyScheduleConstant.Cancel}</p>
                                <ReusableButton className="SaveFieldModal" buttonText="Save" onClick={this.handleSaveEdit} />
                            </div>
                        </div>
                    </Modal>

                </div>

            </div>
        )
    }
}

export default DashboardAdminModifySchedule
